import '@angular/localize/init';

export * from './lib/feature-tax-corporate-details.module';
export * from './lib/tax-corporate-details/feature-tax-corporate-details.component';
